import {createAction} from '@reduxjs/toolkit'
import {PoliciesTesterTypes} from 'interfaces'

export const getPoliciesTesterDetails = createAction<{
  emailId?: string
  type?: string
  url?: string
}>('getPoliciesTesterDetails')
export const getPoliciesTesterDetailsSuccess =
  createAction<PoliciesTesterTypes>('getPoliciesTesterDetailsSuccess')
export const getPoliciesTesterDetailsFailure = createAction<string>(
  'getPoliciesTesterDetailsFailure',
)

export const resetPoliciesTesterDetails = createAction(
  'resetPoliciesTesterDetails',
)
